import { bankEndPoint } from "./base.config";

export const sp1 = {
  getBankBalance: bankEndPoint + '/api/sp1053/getBankBalance',
  getBankTransactionInfo: `${bankEndPoint}/api/sp1053/getBankTransactionInfo`,
  fetchAll: `${bankEndPoint}/api/sp1053/fetchAll`,
}